import React, { FC, useState } from 'react';
import { useIntl } from 'react-intl';
import { TableColumn } from 'react-data-table-component';
import { Pipeline } from '../../interfaces/Pipeline';
import { useSortable } from '@dnd-kit/sortable';
import { SettingMultiMeetings, SettingMultiMerchants, SettingMultiPipelines, SettingMultiReimbursements } from '../../interfaces/Settings';

interface Props<T extends SettingMultiMeetings | SettingMultiMerchants | SettingMultiPipelines | SettingMultiReimbursements> {
    id: string;
    mode: string;
    selectTemplate: T;
    data: T;
    handleSelectDatabase: (data: T) => void;
    handleDeleteDatabase: (data: T) => void
}

const DragAndDropDatabase = <T extends SettingMultiMeetings | SettingMultiMerchants | SettingMultiPipelines | SettingMultiReimbursements>({ id, mode, selectTemplate, data, handleSelectDatabase, handleDeleteDatabase }: Props<T>) => {
    const [isHovered, setIsHovered] = useState(false);
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id,
        transition: {
            duration: 300, // Longer duration for a smoother transition
            easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)', // Natural easing
        },
    });

    const style = transform
        ? {
            transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
            boxShadow: isDragging ? '0 4px 8px rgba(0, 0, 0, 0.1)' : 'none',
            padding: '0px',
            backgroundColor: 'white'
        }
        : {
            padding: '0px'
        };

    return (
        <div className="d-flex flex-stack cursor-pointer" ref={setNodeRef} style={style} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
            {
                mode === 'edit' &&
                <div className={`${isHovered ? 'd-block cursor-move' : 'd-none'} me-3 ms-2`} {...attributes} {...listeners}>
                    <i className="fas fa-grip-vertical"></i>
                </div>
            }
            <div onClick={() => handleSelectDatabase(data)} className={`fs-6 fw-bolder text-gray-800 text-hover-primary w-100 ${selectTemplate.id === data.id ? 'text-active-primary active' : ''}`}>{data.name}</div>
            {
                mode === 'normal' ?
                    <></>
                    // <div className="badge badge-light-success" onClick={() => handleSelectDatabase(data)}>9</div>
                    :
                    <div className="text-hover-danger" onClick={() => handleDeleteDatabase(data)}>
                        <span className="svg-icon svg-icon-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="black"></path>
                                <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="black"></path>
                                <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="black"></path>
                            </svg>
                        </span>
                    </div>
            }
        </div>
    );
};

export { DragAndDropDatabase };
